import React, { useState } from "react";
import axios from "axios";

export const Payment = () => {
  const [amount, setAmount] = useState(100);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleVideoPayClick = async () => {
    setLoading(true);
    setMessage("");
    try {
      // Call backend payment API
      const res = await axios.post("/api/pay_page", {
        planId: "YOUR_PLAN_ID_HERE", // replace with actual plan id
        amount,
        clientIp: "1", // optional
      });

      if (res.data.status) {
        const { redirectUrl } = res.data.data;
        setMessage("Payment initiated, redirecting...");
        // Redirect to PhonePe payment page or test simulator
        window.location.href = redirectUrl;
      } else {
        setMessage("Payment initiation failed.");
      }
    } catch (error) {
      console.error(error);
      setMessage("Error initiating payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid white",
        width: "200px",
        padding: "20px",
        borderRadius: "7px",
      }}
    >
      <span>You have to pay</span>
      <span
        style={{
          border: "1px solid white",
          width: "70px",
          textAlign: "center",
          borderRadius: "5px",
          color: "green",
        }}
      >
        {amount} ₹
      </span>
      <p>for this gold plan...</p>
      <button
        style={{
          backgroundColor: "skyblue",
          borderRadius: "10px",
          padding: "2px 15px",
          cursor: "pointer",
        }}
        onClick={handleVideoPayClick}
        disabled={loading}
      >
        {loading ? "Processing..." : "Make Payment"}
      </button>

      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
    </div>
  );
};
